module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "about exclusive-seo"
  }, [_c('div', {
    staticClass: "default__bg"
  }), _vm._v(" "), _c('sk-container'), _vm._v(" "), _c('sk-container', {
    attrs: {
      "fluid": ""
    }
  }, [_c('sk-layout', [(!_vm.$breakpoints.xs) ? _c('sk-flex', {
    attrs: {
      "sm2": ""
    }
  }) : _vm._e(), _vm._v(" "), _c('sk-flex', {
    attrs: {
      "xs12": "",
      "sm8": ""
    }
  }, [_c('sk-panel', {
    attrs: {
      "transparent": ""
    }
  }, [_c('h1', [_vm._v("Exclusive to SK")]), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.$breakpoints.mdUp) ? _c('sk-google-ad', {
    staticClass: "text-center",
    attrs: {
      "advert-id": _vm.googleAds.topLg,
      "width": 728,
      "height": 90
    }
  }) : _c('sk-google-ad', {
    staticClass: "text-center",
    attrs: {
      "advert-id": _vm.googleAds.top,
      "width": 320,
      "height": 50
    }
  })], 1)], 1), _vm._v(" "), (!_vm.$breakpoints.xs) ? _c('sk-flex', {
    attrs: {
      "sm2": ""
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('sk-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('sk-flex', {
    attrs: {
      "sm2": ""
    }
  }, [(_vm.$breakpoints.mdUp) ? _c('sk-google-ad', {
    staticClass: "exclusive-lefty",
    attrs: {
      "advert-id": _vm.googleAds.left,
      "width": 280,
      "height": 800
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('sk-flex', {
    attrs: {
      "xs12": "",
      "sm8": ""
    }
  }, [_c('div', {
    staticClass: "content-wrapper"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.$breakpoints.xs == true || _vm.$breakpoints.sm == true),
      expression: "$breakpoints.xs == true || $breakpoints.sm == true"
    }]
  }, _vm._l((_vm.tabs), function(tab, index) {
    return _c('sk-accordian', {
      key: index,
      nativeOn: {
        "click": function($event) {
          $event.stopPropagation();
          _vm.pushRoute(tab)
        }
      }
    }, [_c('template', {
      slot: "header"
    }, [_c('h2', {
      staticClass: "faq__cat-title",
      attrs: {
        "data-url": tab.path
      }
    }, [_vm._v(_vm._s(tab.name))])]), _vm._v(" "), _c('template', {
      slot: "content"
    }, [_c('sk-panel', [_c('router-view')], 1)], 1)], 2)
  })), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.$breakpoints.xs == false && _vm.$breakpoints.sm == false),
      expression: "$breakpoints.xs == false && $breakpoints.sm == false"
    }]
  }, [_c('sk-tabs', {
    attrs: {
      "size": _vm.tabs.length
    }
  }, [_c('template', {
    slot: "tab-title"
  }, _vm._l((_vm.tabs), function(tab, index) {
    return _c('sk-tab', {
      key: tab.name,
      class: (_vm.activeTab == index ? 'active' : ''),
      attrs: {
        "item": tab.name
      },
      nativeOn: {
        "click": function($event) {
          $event.stopPropagation();
          _vm.activeTab = index
        }
      }
    })
  })), _vm._v(" "), _c('template', {
    slot: "tab-content"
  }, [_c('sk-panel', [_c('router-view')], 1)], 1)], 2)], 1)])]), _vm._v(" "), _c('sk-flex', {
    attrs: {
      "sm2": ""
    }
  }, [(_vm.$breakpoints.mdUp) ? _c('sk-google-ad', {
    staticClass: "exclusive-righty",
    attrs: {
      "advert-id": _vm.googleAds.right,
      "width": 280,
      "height": 800
    }
  }) : _vm._e()], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d7d17c2e","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/pages/exclusive-to-sk/exclusive-to-sk.vue
// module id = 687
// module chunks = 0